import {gql} from "apollo-angular";
import { baseResponseGraphqlField } from "../../../base.graphql";
import { wardFields } from "../wards/wards.graphql";

export const streetFields = `
id
streetUniqueId
streetName
streetPostcode
napaId
streetParentWard {
  ${wardFields}
}
`

export const GET_ALL_STREETS = gql`
query GetAllStreets($wardUniqueId: String) {
  getAllStreets(wardUniqueId: $wardUniqueId) {
    ${baseResponseGraphqlField}
    data {
      ${streetFields}
    }
  }
}
`
